// ExampleSVGIcon.jsx
import React from "react";

const SVGIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="elements">
      <path
        id="Vector"
        d="M2.5184 7.96149C1.88638 6.85946 1.58121 5.95957 1.3972 5.04739C1.12506 3.6983 1.74785 2.38046 2.77957 1.53957C3.21561 1.18417 3.71547 1.3056 3.97332 1.76818L4.55544 2.81252C5.01684 3.6403 5.24754 4.05418 5.20178 4.49298C5.15602 4.93178 4.84489 5.28916 4.22263 6.00392L2.5184 7.96149ZM2.5184 7.96149C3.79765 10.1921 5.8052 12.2008 8.03841 13.4815M8.03841 13.4815C9.14044 14.1135 10.0403 14.4187 10.9525 14.6027C12.3016 14.8748 13.6194 14.252 14.4603 13.2203C14.8157 12.7843 14.6943 12.2844 14.2317 12.0266L13.1874 11.4445C12.3596 10.9831 11.9457 10.7524 11.5069 10.7981C11.0681 10.8439 10.7107 11.155 9.99598 11.7773L8.03841 13.4815Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default SVGIcon;
